import React from "react";
import { PropTypes } from "prop-types";
import {
    DeviceDowntimeEdit,
    DeviceDowntimeLoader,
    DeviceEditPageHeader,
    DeviceCertifiedModeInfoModal,
    DowntimeNoteLoader,
} from "application/device-settings/components";
import { MrbFieldInput } from "mrb/components/input";
import { MrbEditPage } from "mrb/components/layout";
import { MrbContentLoader, MrbFormFieldContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { MrbButton, MrbPageHeader } from "mrb";
import { MrbSelect } from "mrb/components/select";
import { MrbFieldToggle } from "mrb/components";
import { applicationDefaults } from "common/constants";
import { ToggleActionsLoader } from "common/components";
function DeviceEditTemplate({ deviceEditViewStore, t = (i) => i }) {
    const {
        form,
        deviceDowntimeEditViewStore,
        loaderStore,
        navigateBack,
        cancelLabel,
        submitLabel,
        onClickCancel,
        title,
        layoutActions,
        navigationOptions,
        isDowntimeDisabled,
        modeSelectStore,
        certifiedModeInfoModal,
        openCertifiedModeInfoModal,
    } = deviceEditViewStore;

    return (
        <MrbEditPage store={deviceEditViewStore} t={t} submitLabel="Update Device">
            <MrbPageHeader>
                <DeviceEditPageHeader
                    form={form}
                    onClickCancel={onClickCancel}
                    title={title}
                    layoutActions={layoutActions}
                    navigateBack={navigateBack}
                    navigationOptions={navigationOptions}
                    submitLabel={submitLabel}
                    cancelLabel={cancelLabel}
                    store={deviceEditViewStore}
                    t={t}
                />
            </MrbPageHeader>

            {!isDowntimeDisabled && (
                <div className="c-container--sidebar c-container--sidebar--secondary u-padd--none u-mar--bottom--med">
                    <div
                        className={`c-card c-card--${
                            loaderStore.loading || loaderStore._initial ? "primary" : "message c-card--message--info"
                        }`}
                    >
                        <MrbContentLoader
                            loaderStore={loaderStore}
                            loaderRender={() => <DowntimeNoteLoader fieldWidth={380} />}
                        >
                            {() => (
                                <div className="u-animation--fadeIn">
                                    Downtime is an option that enables you to lock the device at a certain time.
                                </div>
                            )}
                        </MrbContentLoader>
                    </div>
                </div>
            )}
            <div className="c-container--sidebar c-container--sidebar--secondary u-padd--none u-mar--bottom--med">
                <div className="c-card c-card--primary c-card--med">
                    <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <MrbFormFieldContentLoader />}>
                        {() => (
                            <div className="u-animation--fadeIn">
                                <MrbFieldInput
                                    classNameExtend="c-input--outline"
                                    t={t}
                                    field={form.$("deviceName")}
                                    maxLength={applicationDefaults.maxCharactersLength}
                                />
                            </div>
                        )}
                    </MrbContentLoader>
                </div>

                {!isDowntimeDisabled && (
                    <div className="c-card c-card--primary c-card--med">
                        <MrbContentLoader
                            loaderStore={loaderStore}
                            loaderRender={() => <MrbFormFieldContentLoader col={3} />}
                        >
                            {() => (
                                <div className="u-animation--fadeIn">
                                    <div className="u-type--sml u-mar--bottom--tny">Presets</div>
                                    <div className="u-display--flex u-display--flex--jc--space-between u-display--flex--wrap">
                                        <div className="u-display--flex">
                                            <MrbButton
                                                classNameExtend="u-mar--right--tny u-mar--bottom--tny"
                                                label="Nights off"
                                                onClick={deviceDowntimeEditViewStore.disableNight}
                                            ></MrbButton>
                                            <MrbButton
                                                classNameExtend="u-mar--right--tny u-mar--bottom--tny"
                                                label="Shabbos"
                                                onClick={deviceDowntimeEditViewStore.disableShabbos}
                                            ></MrbButton>
                                        </div>
                                        <div className="u-display--flex">
                                            <MrbButton
                                                classNameOverride="c-btn c-btn--base c-btn--ghost u-mar--bottom--tny"
                                                label="Reset"
                                                onClick={deviceDowntimeEditViewStore.reset}
                                            ></MrbButton>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </MrbContentLoader>
                    </div>
                )}
                <div className="c-card c-card--primary c-card--med">
                    <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <MrbFormFieldContentLoader />}>
                        {() => (
                            <div>
                                <div className="u-type--sml u-mar--bottom--tny">Content Mode</div>
                                <div className="u-animation--fadeIn">
                                    <div className="u-display--flex u-display--flex--ai--center u-gap--sml">
                                        <MrbSelect
                                            classNameExtend="c-dropdown--dark c-dropdown--sml-custom"
                                            t={t}
                                            store={modeSelectStore}
                                        />
                                        <button
                                            type="button"
                                            style={{
                                                background: "none",
                                                border: "none",
                                                color: "#2e99ff",
                                                padding: 0,
                                                cursor: "pointer",
                                            }}
                                            onClick={openCertifiedModeInfoModal}
                                        >
                                            {t("APPLICATION.DEVICE_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.INFO_BUTTON")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </MrbContentLoader>
                </div>
                <div className="c-card c-card--primary c-card--med">
                    <MrbContentLoader
                        loaderStore={loaderStore}
                        loaderRender={() => <ToggleActionsLoader lineheight={25} rows={1} sidebarLrg />}
                    >
                        {() => (
                            <div className="u-animation--fadeIn">
                                <div className="u-type--sml u-mar--bottom--tny">Home screen settings</div>
                                <div className="c-sidebar__item">
                                    <div className="u-type--base">
                                        {t("APPLICATION.DEVICE_SETTINGS.EDIT.FIELDS.HIDE_TRENDING")}
                                    </div>
                                    <MrbFieldToggle
                                        t={t}
                                        field={form.$("hideTrending")}
                                    />
                                </div>
                            </div>
                        )}
                    </MrbContentLoader>
                </div>
            </div>
            {!isDowntimeDisabled && (
                <div className="c-card--primary c-card--med u-overflow--hidden">
                    <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <DeviceDowntimeLoader />}>
                        {() => <DeviceDowntimeEdit store={deviceDowntimeEditViewStore} t={t} />}
                    </MrbContentLoader>
                </div>
            )}

            <DeviceCertifiedModeInfoModal modalParams={certifiedModeInfoModal} />
        </MrbEditPage>
    );
}

DeviceEditTemplate.propTypes = {
    deviceEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(DeviceEditTemplate);
